export const LOWEST_SUBJECT_GRADE = 2;
